import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
/**
 * TableFooterCell is a React component which displays footer cells content.
 */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export default function TableFooterCell(props) {
  const {
    column,
    heading,
    data,
    footerCellComponent: TD,
    className
  } = props;
  const {
    className: footerColumnClassName
  } = column;
  /*
   * Todo: uncomment below code in this ticket- WZSD-133
   * expandableCell prop is used to render the expandable button.
   * const { expandableCell } = column;
   */

  const tableFooterHeadingClassName = clsx("wf-table__cell", className, footerColumnClassName);
  const tableFooterCellClassName = clsx("wf-table__cell", className, footerColumnClassName); // eslint-disable-next-line react/prop-types

  const colSpan = column === null || column === void 0 ? void 0 : column.colspan;
  const headingContent = heading === null || heading === void 0 ? void 0 : heading.content;
  const headerContent = typeof headingContent === "function" ? headingContent(data) : headingContent;
  const cellContent = typeof column.content === "function" ? column.content(data) : column.content;
  /**
   * Todo: Toggle comment after expandable implementation - WZSD-133
   * In the expandable button cell, headerContent is used to generate
   * the aria-label.
   * if (expandableCell) {
   * cellContent = expandableCell(headerContent);
   * }
   */

  return colSpan >= 1 && headerContent ? _jsx("th", {
    className: tableFooterHeadingClassName,
    colSpan: colSpan,
    scope: "row",
    children: headerContent
  }) : _jsx(TD, {
    className: tableFooterCellClassName,
    children: cellContent
  });
}
TableFooterCell.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The current column */
  column: PropTypes.shape({
    /** The key to locate the value for the column inside each record. */
    key: PropTypes.string.isRequired,

    /** The display label used when the column is collapsed. */
    label: PropTypes.string,

    /** The content of the specific column footer cell. */
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

    /** The className of the specific footer column cell. */
    className: PropTypes.string
  }).isRequired,

  /** The data passed to the table. This attribute takes an array of objects. */
  data: PropTypes.arrayOf(PropTypes.object),
  // eslint-disable-line react/forbid-prop-types

  /** The Component that renders the footer cell. */
  footerCellComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /** The table footer heading. */
  heading: PropTypes.shape({
    /** The colspan attribute applied to the first columns. */
    colspan: PropTypes.number,

    /** The heading content of the table footer. */
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

    /** The className of the footer header element. */
    className: PropTypes.string
  })
} : {};
TableFooterCell.defaultProps = {
  data: [],
  heading: null,
  footerCellComponent: "td"
};